import { ComputerDesktopIcon, DevicePhoneMobileIcon } from "@heroicons/react/24/outline";
import { viewportLabel } from "@/components/audits/replay/helpers";

type Props = {
  viewport: string;
};

export default function ViewportChip({ viewport }: Props) {
  const Icon = viewport === "mobile" ? DevicePhoneMobileIcon : ComputerDesktopIcon;
  const label = viewportLabel(viewport);

  return (
    <span className="inline-flex shrink-0 items-center gap-1 text-xs text-gray-500" title={label}>
      <span className="sr-only">{label}</span>
      <Icon className="h-4 w-4 text-gray-400" aria-hidden="true" />
    </span>
  );
}
